import React from "react";

import AccountLogo from "assets/logo/logo.svg";

import "./SplashScreen.less";

export function SplashScreen() {
  return (
    <div className="splash-screen">
      <img
        src={AccountLogo}
        className="splash-screen__logo"
        alt="Store Logo"
      />
    </div>
  );
}
